import { useQuery } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

/**
 * Fetches the contract information
 * @param {} context - react query context
 * @returns {Promise<object>} - CurrentUser information
 */

function fetchModeOfTransportation () {
  return fetch('/referenceData/getDropdownOptions?dropdown=incident.modeOfTransportation')
    .then(decodeJson)
    .catch(({ body, status }) => {
      if (status === 404) {
        throw new ApiError('Unable to get the mode of transportation');
      }
      throw new ApiError(body ? `Error: ${ body }` : 'Unable to retrieve mode of transportation. Please reload the page and try again');
    });
}

const useModeOfTransportation = () => {
  const value = useQuery({
    queryKey: ['useModeOfTransportation'],
    queryFn: fetchModeOfTransportation,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });
  return value;
};

export default useModeOfTransportation;
